export enum FeatureState {
  Initial = "Initial",
  Loading = "Loading",
  Success = "Success",
  Error = "Error",
}
